import { GlobalState } from 'reducers';
import { getIsFeatureEnabledForUser } from 'selectors/features/getIsFeatureEnabledForUser';
import { Feature } from 'types/types';

export const getIsMissingDocsNoticesEnabled = (state: GlobalState) =>
  getIsFeatureEnabledForUser(state, {
    feature: Feature.MissingDocumentsNotices,
  });
